<script setup>
import { computed} from "vue";
import { translator } from "@shop/frontend/web/js/services/TranslatorService";
import Popper from "vue3-popper";


const props = defineProps({
	bulkBuyTeacherParams : {
		type: [Object, null],
		default: null,
	},
	countOrderEvents : {
		type: Number,
		required: true,
	},
	smallBtn: {
		type: Boolean,
		default: false,
	},
});

const acquiringButtonClass = computed(() => {
	return {
		"i-acquirings-button_small": props.smallBtn,
		"i-acquirings-button_disabled": props.countOrderEvents > 1,
	};
});

const emit = defineEmits(["setAcquiringError", "openCollectivePurchaseModal"]);

</script>

<template>
	<div class="i-acquirings-button__link-wrapper">
		<button
			class="btn i-acquirings-button"
			:class="acquiringButtonClass"
			@click="emit('openCollectivePurchaseModal')"
		>
			<slot>
				<svg class="icon i-acquirings-button__icon" width="20" height="20">
					<use xlink:href='#bulk-buy-teacher'></use>
				</svg>
				<template v-if="bulkBuyTeacherParams"> {{ translator.t("main", "Collective purchase")}} </template>
			</slot>
		</button>
		<Popper
			class="light i-acquirings-button__popper"
			placement="top"
			arrow
			hover
			:content="translator.t('order', 'You can generate a link for collective purchase of tickets if there is only 1 event in your order')"
		>
			<svg class="i-acquirings-button__pushkin-tooltip" width="12" height="12" fill="none">
				<use xlink:href="#attention"></use>
			</svg>
		</Popper>
	</div>
</template>

<style scoped lang="scss">
@import "frontend/web/src/styles/utils/variables.scss";
@import "../IAcquiringsButton/i-acquirings-button.scss";

:deep(.popper) {
	width: 280px;
	padding: 5px;

	border-radius: 6px;
	box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.05);
	background-color: #fff;

	color: #000;
	text-align: center;
	font-size: 14px;
	font-weight: 400;
}

:deep(.popper #arrow::before) {
	transform: translateX(-5px) rotate(45deg);
	background: #fff;
}
</style>
